import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import DifferentValueThanLeaseWarning from './component';
import { closeNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => {
  const { rentalProtectionDisclaimers, paymentSettings } = state.payments.landlord.onboarding[propertyId];
  const { listingAlias } = state.payments.landlord.property;
  const { editMode } = paymentSettings;

  return {
    editMode,
    rentalProtectionDisclaimers,
    listingAlias,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl }) => ({
  onContinue: (editMode) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => {
        if (editMode) {
          return dispatch(push(baseUrl + paths.onboarding.confirmationPage));
        }
        return dispatch(push(baseUrl + paths.onboarding.dueDatePage));
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onContinue: () => {
    const { editMode } = stateProps;
    return dispatchProps.onContinue(editMode);
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DifferentValueThanLeaseWarning);
